






















import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import SearchProducer from '@/mixins/search-queries/search-producer'
import SearchBook from '@/mixins/search-queries/search-book'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { IPolicySourceInput } from '@/modules/Policy/interfaces/policy-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField
  }
})
export default class PolicyFormSource extends mixins(SearchProducer, SearchBook) {
  @Prop({ type: Object as () => IPolicySourceInput }) value!: IPolicySourceInput
  @Prop({ type: Object as () => Producer }) readonly source!: Producer

  get sourceDisable () {
    return !!this.source
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
